import {useHistory} from "react-router-dom";
import React, {useEffect, useMemo, useState} from "react";
import {UserContext} from "../../contexts/UserContext";
import {filterBy, orderBy} from "@progress/kendo-data-query";
import {semcastAxios, showErrorToastMessage, showSuccessToastMessage, signInAs} from "../../Utils/Common";
import {Super_ADMIN_CREATIVE_TAGs} from "../../api/constants";
import {Button, DropDownButton, DropDownButtonItem} from "@progress/kendo-react-buttons";
import LoadOverlay from "../Components/SharedComponents/LoadOverlay";
import {ExcelExport} from "@progress/kendo-react-excel-export";
import {Grid, GridToolbar} from "@progress/kendo-react-grid";
import {GridColumn as Column} from "@progress/kendo-react-grid/dist/npm/GridColumn";
import { HeaderThElement } from '@progress/kendo-react-data-tools';

import moment from "moment";
import {DropdownFilterCell} from "../Components/Permission/dropdownFilterCell";
const initialFilter = {
    logic: "and",
    filters: [
        {
            field: "domain",
            operator: "contains",
            value: ""
        }
    ]
};

const initialSort = [
    {
        field: "domain",
        dir: "asc"
    }
];

function formatUnixTime(unixTime) {
    if(unixTime == null) return null;

    const date = new Date(unixTime);
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear().toString().slice(-2);
    return `${month}/${day}/${year}`;
}

function getCurrentDateTime() {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    const day = currentDate.getDate().toString().padStart(2, '0');
    const hours = currentDate.getHours().toString().padStart(2, '0');
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');

    const currentDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return currentDateTime;
}

const AdminCreativeTagManager = () => {
    const history = useHistory();
    const [overlayActive, setOverlayActive] = useState(false);
    const [data, setData] = useState([]);
    const [filter, setFilter] = useState(initialFilter);
    const [sort, setSort] = useState(initialSort);
    const [skip, setSkip] = useState(0);
    const [take, setTake] = useState(25);

    const processedData = useMemo(() => orderBy(filterBy(data, filter), sort), [data, filter, sort]);
    useEffect(() => {
        const total = processedData.length;
        if (total === 0) {
            setSkip(0);
            return;
        }
        if (skip >= total) {
            const newSkip = Math.max(total - take, 0);
            if (newSkip !== skip) {
                setSkip(newSkip);
            }
        }
    }, [processedData, skip, take]);
    const [showTagCode, setShowTagCode] = useState(false);
    const [pixelTagId, setPixelTagId] = useState("");
    const [pixelTagObj, setPixelTagObj] = useState({});


    const {user, setUser} = React.useContext(UserContext);

    const exportExcell = React.useRef(null);
    const exportExport = () => {
        if (exportExcell.current !== null) {
            exportExcell.current.save(orderBy(filterBy(data, filter), sort));
        }
    };


    const getCreativeTagsData = async () => {
        try {
            let response = await semcastAxios.get(Super_ADMIN_CREATIVE_TAGs, {withCredentials: true})
                .then((res) => {
                    console.log(res)
                    let dataTemp = res.data.creativeTags;
                    dataTemp.forEach((idxTag) => {
                        idxTag.userName = idxTag.firstName + " " + idxTag.lastName;
                        const createdAtDateString = idxTag.createdAt;
                        if(typeof createdAtDateString === 'string'){
                            const [datePart, timePart] = createdAtDateString.split(" ");
                            idxTag.createdAt = moment(datePart, 'YYYY-MM-DD').toDate();
                        }
                    })
                    console.log(dataTemp)
                    setData(dataTemp);
                    console.log("dataTemp ", dataTemp);
                    setOverlayActive(false);
                }).catch((error) => {
                    if (error.response) {
                        showErrorToastMessage("Response Error: " + error.response.data.data, 10);
                        console.log(error.response);
                    }
                    if (error.request) {
                        showErrorToastMessage("Request Error: " + error.request.data.data, 10);
                        console.log(error.request);
                    }
                });
        } catch (error) {
            console.log(error)
            showErrorToastMessage("Error accessing Tracking Pixel information. " + error);
        }

    }


    useEffect(async () => {
        setOverlayActive(true);
        getCreativeTagsData();

    }, []);
    const categoryFilterCell = props => {
        const types = Array.from(new Set(data.map(p => p[props.field] ? p[props.field] : ''))).sort((a, b) => a.localeCompare(b));
        return (
            <DropdownFilterCell {...props} data={types} defaultItem={'Select Filter...'} style={{ width: 'auto' }} />
        )
    }

    const createdAtCell = (props) => {
        const newDateOptions = {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        }
        const dateString = props.dataItem[props.field].toLocaleString("en-US", newDateOptions ) ? props.dataItem[props.field].toLocaleString("en-US", newDateOptions ) : "-" ;


        return (
            <td key={props.dataItem.id} className={"k-text-center"}>
                {dateString}
            </td>
        )
    };
    const deletedAtCell = (props) => {
        const newDateOptions = {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        }
        const dateString = props.dataItem[props.field].toLocaleString("en-US", newDateOptions ) ? props.dataItem[props.field].toLocaleString("en-US", newDateOptions ) : "-" ;


        return (
            <td key={props.dataItem.id} className={"k-text-center"}>
                {dateString}
            </td>
        )
    };
    const emailCell = (props) => {
        // console.log("updatedCell ", props);
        const email = props.dataItem.email ? props.dataItem.email : "-" ;
        return (
            <td key={props.dataItem.id} className={"k-text-center"}>
                {email}
            </td>
        )
    };
    const platformCell = (props) => {
        // console.log("updatedCell ", props);
        const platform = props.dataItem.platform ? props.dataItem.platform : "-" ;
        return (
            <td key={props.dataItem.id} className={"k-text-center"}>
                {platform}
            </td>
        )
    };

    const pixelReceivedFilterCell = (props) => {
        const options = ["True", "False"];
        return (
            <DropdownFilterCell
                {...props}
                data={options}
                defaultItem={'Select Filter...'}
                style={{ width: 'auto' }}
            />
        );
    };

    const nameCell = (props) => {
        // console.log("updatedCell ", props);
        const nameLabel = props.dataItem.userName ? props.dataItem.userName : "-" ;
        return (
            <td key={props.dataItem.id} className={"k-text-center"}>
                {nameLabel}
            </td>
        )
    };
    const companyCell = (props) => {
        const segmentNamingType = props.dataItem.company ? props.dataItem.company : "-" ;

        return (
            <td key={props.dataItem.id} className={"k-text-center"}>
                {segmentNamingType}
            </td>
        )
    };
    const pixelReceivedCell = (props) => {
        const segmentNamingType = props.dataItem.pixelReceived == 0 ? "False" : "True" ;

        return (
            <td key={props.dataItem.id} className={"k-text-center"}>
                {segmentNamingType}
            </td>
        )
    };


    const headerCell = props => {
        return <div style={{
            textAlign: '-webkit-center'
        }}>
            <span style={{
                textAlign: '-webkit-center'
            }}>{props.title}</span>
        </div>;
    };



    const filterOperators = {
        text: [{
            text: 'grid.filterContainsOperator',
            operator: 'contains'
        }],
        numeric: [{
            text: 'grid.filterEqOperator',
            operator: 'eq'
        }],
        date: [{
            text: 'grid.filterEqOperator',
            operator: 'eq'
        }],
        boolean: [{
            text: 'grid.filterEqOperator',
            operator: 'eq'
        }]
    };
    return (
        <div>
            <LoadOverlay active={overlayActive} height={50} width={50}>

                <div className={"idx-tag-manager-outer-container"}>
                    <div className={"idx-grid"}>
                        <ExcelExport ref={exportExcell} fileName={`Creative Tags - ${user.first_name} ${user.last_name} ${getCurrentDateTime()}`}>
                            <Grid
                                style={{ height: '65vh' }}
                                data={processedData.slice(skip, skip + take)}
                                skip={skip}
                                take={take}
                                total={processedData.length}
                                filterable={true}
                                filter={filter}
                                filterOperators={filterOperators}
                                onFilterChange={(e) => setFilter(e.filter)}
                                sortable={true}
                                sort={sort}
                                onSortChange={(e) => {
                                    setSort(e.sort);
                                }}
                                resizable={true}
                                pageable={{ buttonCount: 5, pageSizes: [10, 25, 50, 100] }}
                                onPageChange={(e) => {
                                    setSkip(e.page.skip);
                                    setTake(e.page.take);
                                }}
                            >
                                <GridToolbar>
                                    <div className={"idx-grid-toolbar-container"}>
                                        <div className={"idx-grid-toolbar-left"}>

                                        </div>
                                        <div className={"idx-grid-toolbar-right"}>
                                            <Button
                                                className={"button-standard button-white"}
                                                iconClass={"k-icon k-i-download"}
                                                onClick={exportExport}
                                            >
                                                as CSV
                                            </Button>
                                        </div>
                                    </div>
                                </GridToolbar>
                                <Column field={"creativeTagId"} title={"Creative Tag ID"}/>
                                <Column field={"company"} title={"Company"} cell={companyCell} filterCell={categoryFilterCell}/>
                                <Column field={"platform"} title={"Platform"} cell={platformCell} filterCell={categoryFilterCell}/>
                                <Column field={"createdAt"} title={"Created"} cell={createdAtCell} filter="date" format="{0:d}"/>
                                {/*<Column field={"deletedAt"} title={"Deleted"} headerCell={headerCell} cell={deletedAtCell} filter="date" format="{0:d}"/>*/}
                                <Column field={"userName"} title={"User"} cell={nameCell} filterCell={categoryFilterCell}/>
                                <Column field={"email"} title={"Email"} cell={emailCell}/>
                                <Column
                                    field={"pixelReceived"}
                                    title={"Pixel Received"}
                                    cell={pixelReceivedCell}
                                    filterCell={pixelReceivedFilterCell}
                                />
                            </Grid>
                        </ExcelExport>
                    </div>
                </div>
            </LoadOverlay>
        </div>
    )
}
export default AdminCreativeTagManager;
